import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'
const moment = require('moment')
require('moment/locale/sv')

Vue.use(require('vue-moment'), {
  moment
});
Vue.use(TurbolinksAdapter)